import { datadogRum } from '@datadog/browser-rum';
import { reactPlugin } from '@datadog/browser-rum-react';

import { getLocalStorage } from './hooks/useLocalStorage';
import { getRealm, isRealmLive } from './utils/realm';

const realm = getRealm();

export function isDatadogEnabled(): boolean {
  const localStorageDisableFlag = getLocalStorage('METER:DATADOG:DISABLED', false);

  return isRealmLive(realm) && !localStorageDisableFlag;
}

export function initDatadog() {
  if (
    isDatadogEnabled() &&
    import.meta.env.DATADOG_APPLICATION_ID &&
    import.meta.env.DATADOG_CLIENT_TOKEN
  ) {
    datadogRum.init({
      applicationId: import.meta.env.DATADOG_APPLICATION_ID,
      clientToken: import.meta.env.DATADOG_CLIENT_TOKEN,
      // `site` refers to the Datadog site parameter of your organization
      // see https://docs.datadoghq.com/getting_started/site/
      site: 'datadoghq.com',
      service: 'dashboard',
      proxy: (options) => {
        const path = options.path.replace('rum', 'r');
        return `/dd${path}?${options.parameters}`;
      },
      env: realm,
      version: import.meta.env.VERCEL_GIT_COMMIT_SHA,
      sessionSampleRate: 100,
      sessionReplaySampleRate: 20,
      trackUserInteractions: true,
      trackResources: true,
      trackLongTasks: true,
      defaultPrivacyLevel: 'mask-user-input',
      enableExperimentalFeatures: ['feature_flags', 'writable_resource_graphql'],
      allowedTracingUrls: [
        {
          propagatorTypes: ['tracecontext'],
          match: (url: string) => {
            // uncomment when debugging
            // if (realm === 'local') {
            //   return (
            //     url.startsWith('https://portal.meter.website:8556') ||
            //     url.startsWith('https://dashboard.meter.website:8556')
            //   );
            // }
            if (realm === 'dev') {
              return url.startsWith('https://portal.meter.dev');
            }
            if (realm === 'prod') {
              return url.startsWith('https://portal.meter.com');
            }
            return false;
          },
        },
      ],
      plugins: [reactPlugin()],
    });
  }
}
